module.exports = __webpack_public_path__ + "assets/overlay--crane.9cf68cd81b7e43ed3e28cd5f8c0853d0.svg";


//////////////////
// WEBPACK FOOTER
// ../static/images/overlays/overlay--crane.svg
// module id = 437
// module chunks = 0